module.exports = __webpack_public_path__ + "static/media/userHam.68f2a6aa.svg";